import React from "react";
import styles from "./Css/SeriesTopTen.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Scrollbar,
  A11y,
  Mousewheel,
  FreeMode,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useAudiosByAudioType } from "../../hooks/useAudiosHooks";
import { useNavigate } from "react-router-dom";

const SeriesTopTen = () => {
  const {
    data: response,
    isLoading,
    error,
  } = useAudiosByAudioType("Audio Book", { limit: 10 });
  const navigate = useNavigate();

  // Handle loading state
  if (isLoading) {
    return <div className={styles.loading}>Loading top audiobooks...</div>;
  }

  // Handle error state
  if (error) {
    return <div className={styles.error}>Failed to load top audiobooks</div>;
  }

  // If no data or empty data, don't render anything
  if (!response || !response.data || response.data.length === 0) {
    return null;
  }

  const audioBooks = response.data;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Top 10 Audio Books</h2>
      <Swiper
        freeMode={{
          enabled: true,
          momentum: true,
          momentumRatio: 1, // smoother momentum
          momentumVelocityRatio: 1, // normal velocity handling
          minimumVelocity: 0.02, // keep this small to allow tiny moves
        }}
        modules={[Mousewheel, FreeMode, Navigation, Scrollbar, A11y]}
        mousewheel={{
          forceToAxis: true,
          sensitivity: 0.5, // Lower sensitivity for smoother movement
          releaseOnEdges: true,
        }}
        speed={400} // Reduce speed slightly for softer acceleration
        resistance={true} // Allow a bit of resistance (helps feel natural)
        resistanceRatio={0.85}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
            320: {
              slidesPerView: 2.2,
              spaceBetween: 30,
            },
            480: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 3.5,
              spaceBetween: 40,
            },
            900: {
              slidesPerView: 4.5,
              spaceBetween: 50,
            },
            1200: {
              slidesPerView: 5.2,
              spaceBetween: 100,
            },
          }}
        className={styles.swiperContainer}
      >
        {audioBooks.map((audioBook, index) => (
          <SwiperSlide key={audioBook.id} className={styles.seriesSlide}>
            <div className={styles.seriesItem}>
              <div
                className={styles.rankContainer}
                onClick={() => navigate(`/audio-play/${audioBook.slug}`)}
              >
                <span
                  onClick={() => navigate(`/audio-play/${audioBook.slug}`)}
                  className={styles.rank}
                >
                  {index + 1}
                </span>
              </div>
              <div className={styles.imageContainer}>
                <img
                  src={
                    audioBook.computer_image_url || audioBook.mobile_image_url
                  }
                  alt={audioBook.series_title || audioBook.title}
                  className={styles.seriesImage}
                  onClick={() => navigate(`/audio-play/${audioBook.slug}`)}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SeriesTopTen;
